import { publicHref } from '../lib/publicUrls';
import { Facebook, Instagram, Music2 } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { emitSemanticEvent } from '../lib/semanticEvents';

const memberLoginUrl = 'https://deltavac.clubautomation.com/';
const phoneHref = 'tel:+19252402990';

const Footer = () => {
  const location = useLocation();

  const recordEvent = (event, properties) => {
    emitSemanticEvent(event, {
      page_path: location.pathname,
      component_context: 'global_footer',
      ...properties,
    });
  };

  return (
    <footer className="dv-footer" data-testid="site-footer">
      <div className="dv-footer__top">
        <div className="dv-footer__brand">
          <img src="/Delta-Valley-Logo.png" alt="Delta Valley Health Club" />
          <p>Fitness, wellness, and community in Brentwood and Discovery Bay since 2002.</p>
          <nav className="dv-footer__social" aria-label="Delta Valley social profiles">
            <a href="https://www.facebook.com/deltavalleyhc" target="_blank" rel="noreferrer" aria-label="Facebook">
              <Facebook aria-hidden="true" />
            </a>
            <a href="https://www.instagram.com/deltavalleyhc/" target="_blank" rel="noreferrer" aria-label="Instagram">
              <Instagram aria-hidden="true" />
            </a>
            <a href="https://www.tiktok.com/@deltavalleyhc" target="_blank" rel="noreferrer" aria-label="TikTok">
              <Music2 aria-hidden="true" />
            </a>
          </nav>
        </div>

        <nav className="dv-footer__explore" aria-label="Footer navigation">
          <h2>Explore</h2>
          <Link to={publicHref("/programs")}>Programs</Link>
          <Link to={publicHref("/schedule")}>Schedule</Link>
          <Link to={publicHref("/amenities")}>Amenities</Link>
          <Link to={publicHref("/membership")}>Membership</Link>
          <Link to={publicHref("/blog")}>Hot Topics</Link>
          <Link to={publicHref("/about-us")}>Our Club</Link>
          <Link to={publicHref("/contact")}>Contact</Link>
          <Link
            to={publicHref("/book-a-tour")}
            onClick={() => recordEvent('book_tour_cta_click', {
              cta_placement: 'footer',
              destination: '/book-a-tour',
              location_context: 'unspecified',
            })}
          >
            Book a Tour
          </Link>
        </nav>

        <section className="dv-footer__location dv-footer__location--primary" aria-labelledby="footer-brentwood">
          <p className="dv-eyebrow">01 · Primary club</p>
          <h2 className={location.pathname.startsWith('/admin') ? 'dv-size-admin-footer-title' : 'dv-size-subheading'} id="footer-brentwood">Brentwood</h2>
          <address>120 Guthrie Ln.<br />Brentwood, CA 94513</address>
          <p>Mon–Thu 4:30am–10:30pm<br />Fri 4:30am–9:00pm<br />Sat–Sun 6:00am–6:00pm</p>
          <a
            href={publicHref(phoneHref)}
            onClick={() => recordEvent('phone_click', {
              destination: phoneHref,
              location_context: 'brentwood',
            })}
          >
            (925) 240-2990
          </a>
          <a
            href="https://maps.google.com/?q=120+Guthrie+Ln+Brentwood+CA+94513"
            target="_blank"
            rel="noreferrer"
            onClick={() => recordEvent('location_interaction', {
              destination: 'google_maps',
              location_context: 'brentwood',
            })}
          >
            Get directions
          </a>
        </section>

        <section className="dv-footer__location" aria-labelledby="footer-discovery-bay">
          <p className="dv-eyebrow">02 · East County</p>
          <h2 className={location.pathname.startsWith('/admin') ? 'dv-size-admin-footer-title' : 'dv-size-subheading'} id="footer-discovery-bay">Discovery Bay</h2>
          <address>1520 Discovery Bay Blvd.<br />Discovery Bay, CA 94505</address>
          <p>Mon–Thu 6:00am–8:00pm<br />Fri 6:00am–5:00pm<br />Sat–Sun 7:00am–2:00pm</p>
          <a
            href={publicHref(phoneHref)}
            onClick={() => recordEvent('phone_click', {
              destination: phoneHref,
              location_context: 'discovery_bay',
            })}
          >
            (925) 240-2990
          </a>
          <a
            href="https://maps.google.com/?q=1520+Discovery+Bay+Blvd+Discovery+Bay+CA+94505"
            target="_blank"
            rel="noreferrer"
            onClick={() => recordEvent('location_interaction', {
              destination: 'google_maps',
              location_context: 'discovery_bay',
            })}
          >
            Get directions
          </a>
        </section>
      </div>

      <div className="dv-footer__details">
        <details>
          <summary>Pool and childcare hours</summary>
          <div>
            <p><strong>Brentwood pool</strong><br />Mon–Thu 4:30am–9:00pm · Fri 4:30am–8:00pm · Sat–Sun 6:00am–5:00pm</p>
            <p><strong>Childcare</strong><br />Monday–Thursday 8:00am–8:00pm · Friday–Sunday 8:00am–1:00pm</p>
          </div>
        </details>
        <a href={publicHref(memberLoginUrl)} target="_blank" rel="noreferrer">Member Login</a>
      </div>

      <div className="dv-footer__legal">
        <p>© 2026 Delta Valley Health Club</p>
        <nav aria-label="Legal">
          <Link to={publicHref("/privacy-policy")}>Privacy</Link>
          <Link to={publicHref("/terms-conditions")}>Terms</Link>
          <Link to={publicHref("/facility-guidelines-and-policies")}>Facility Guidelines</Link>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
